import React, { useState } from 'react';

import { AVAILABILITY_AVAILABLE, errorMessage } from './budgetTags';
import BudgetTagToggle from './BudgetTagToggle';

import Alert from 'CommonComponents/Alert';
import TextButton from 'CommonComponents/TextButton';

// "Use as budget tag" switch and Select all / Clear all for the selected codeset.
// Saves immediately; the parent receives the updated codeset (with counts).
export default function BudgetTagBar({ category, canManageTags, budgetTagUrl, taggableUrl, onUpdated, onItemsChanged }) {
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);

    const isAvailable = category.budget_tag_availability === AVAILABILITY_AVAILABLE;
    const isBudgetTag = !!category.is_budget_tag;

    const save = (url, payload, itemsChanged) => {
        setIsSaving(true);
        setError(null);

        axios
            .put(url.replace('TAG_CATEGORY_ID', category.id), payload)
            .then(({ data }) => {
                onUpdated(data.data);
                itemsChanged && onItemsChanged();
            })
            .catch((e) => setError(errorMessage(e)))
            .finally(() => setIsSaving(false));
    };

    const toggleBudgetTag = (e) => save(budgetTagUrl, { is_budget_tag: e.target.checked }, true);
    const setAllTaggable = (isTaggable) => save(taggableUrl, { is_taggable: isTaggable }, true);

    return (
        <div className="tw-space-y-2">
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2 tw-rounded-lg tw-border tw-border-grey tw-bg-charcoal-10 tw-px-4 tw-py-3">
                <BudgetTagToggle
                    label={$t('Use as budget tag')}
                    checked={isAvailable && isBudgetTag}
                    unavailable={!isAvailable || !canManageTags}
                    disabled={isSaving}
                    onChange={toggleBudgetTag}
                />
                <p className="tw-mb-0 tw-flex-1 tw-text-sm tw-text-charcoal-75">
                    {isAvailable
                        ? `${$t('Items marked taggable can be added to budget lines, projects, cost templates and expense packs.')} ${$t(
                              '{{count}} of {{total}} taggable.',
                              { count: category.taggable_count ?? 0, total: category.tags_count ?? 0 },
                          )}`
                        : `${$t('Not available for {{name}}.', { name: category.name })} ${category.budget_tag_unavailable_reason ?? ''}`}
                </p>
                {isAvailable && isBudgetTag && !!canManageTags && (
                    <div className="tw-flex tw-items-center tw-gap-x-6">
                        <TextButton variant="primary" className="!tw-normal-case" disabled={isSaving} onClick={() => setAllTaggable(true)}>
                            {$t('Select all')}
                        </TextButton>
                        <TextButton variant="primary" className="!tw-normal-case" disabled={isSaving} onClick={() => setAllTaggable(false)}>
                            {$t('Clear all')}
                        </TextButton>
                    </div>
                )}
            </div>
            {error && <Alert type="error">{error}</Alert>}
        </div>
    );
}
